import React, { useState, useEffect } from 'react';
import { callNative } from '@relx/bridge';
import Cookies from 'js-cookie';
import ToastAdaptor from '@/components/Antd5ToastAdaptor';
import { APP_HOST } from '@/const';
import { Platform } from '@/utils/Platform';
import { Api } from '@/api';
import { request } from 'umi';

export default function useAuthModel() {
  const [userInfo, setUserInfo] = useState({
    phone: '',
    level: '',
    nickName: '',
    userId: '',
    token: '',
    userIcon: '',
    crmToken: Cookies.get('token') || '',
  });

  useEffect(() => {
    getRealPhone().then(data => {
      setUserInfo(prev => ({ ...prev, phone: data } as any));
    });
    if (Platform.is('RelxMe')) {
      callNative('getUserInfo').then(async info => {
        setUserInfo(userInfo => ({
          ...userInfo,
          ...info,
        }));
        try {
          const res = await appLoginCrm(info.token || '');
          setUserInfo(userInfo => ({
            ...userInfo,
            ...info,
            crmToken: res,
          }));
        } catch (err) {}
      });
    }
  }, []);

  const isLogin = async () => {
    if (Platform.is('RelxMe') && !userInfo.phone) {
      const res = await callNative('getUserInfo');
      userInfo.phone = res.phone || '';
      setUserInfo(userInfo => ({ ...userInfo, ...res }));
    }

    if (userInfo.crmToken || userInfo.phone || Cookies.get('token')) {
      if (!userInfo.crmToken) {
        userInfo.crmToken = Cookies.get('token') || '';
        setUserInfo(userInfo => ({
          ...userInfo,
          crmToken: Cookies.get('token') || '',
        }));
      }
      await getRealPhone();
      return Promise.resolve(true);
    }
    return Promise.reject(false);
  };

  const appLoginCrm = (token: string) => {
    return request(`${APP_HOST}/dianziyan-api/api/a/auth/getBizToken`, {
      method: 'post',
      data: {
        registerChannel: 'FJMD',
      },
      headers: {
        token,
      },
      skipErrorHandler: true,
    }).then(res => {
      if (res?.code === 0 || res?.code === 200) {
        return res?.data;
      } else {
        throw res;
      }
    });
  };

  const logInCrm = (cb?: string, face = false) => {
    const callback = cb || window.location.href;
    ToastAdaptor.loading('正在登陆', 1);
    setTimeout(() => {
      ToastAdaptor.hide();
      window.location.href = `${APP_HOST}/n/verify?next=${encodeURIComponent(
        callback,
      )}&rc=FJMD${face ? '' : '&wx_auth_direct=1'}`;
    }, 1000);
  };

  const getRealPhone = () => {
    return Api.store.storeFeedbackApi
      .getV1StorePhone(
        {
          token: userInfo.crmToken,
        },
        {
          skipErrorHandler: true,
        },
      )
      .then(res => {
        if (res?.code === 0 || res?.code === 200) {
          return res?.data;
        } else {
          throw res;
        }
      });
  };

  return { userInfo, isLogin, logInCrm, getRealPhone };
}
